// src/constants/emailTemplates.ts (example file)

export const PRE_MADE_TEMPLATES = [
    {
      label: "Welcome Email",
      subject: "Welcome to Our Community!",
      message: `Hello [Name],
  
  We’re so excited to have you with us! 
  
  Here’s everything you need to know to get started...
  
  Best regards,
  The Team`,
      ctaUrl: "https://www.hbinternational.org",
      ctaLabel: "Get Started",
      signature: "Warm regards,\nHope Beyond International",
    },
    {
      label: "Thank You Email",
      subject: "Thank You for Your Support!",
      message: `Dear [Name],
  
  Thank you so much for your kind support. Your contribution helps us continue our mission...
  
  Sincerely,
  Hope Beyond International`,
      ctaUrl: "",
      ctaLabel: "",
      signature: "Best wishes,\nHope Beyond International",
    },
    {
      label: "Event Invitation",
      subject: "You're Invited!",
      message: `Hi [Name],
  
  We'd love for you to join us at our upcoming event. Here are the details...
  
  Hope to see you there!`,
      ctaUrl: "https://www.hbinternational.org/events",
      ctaLabel: "View Event",
      signature: "Cheers,\nHope Beyond International",
    },
  ];
  